import { render, staticRenderFns } from "./job.vue?vue&type=template&id=1d90d99e&scoped=true&"
import script from "./job.vue?vue&type=script&lang=js&"
export * from "./job.vue?vue&type=script&lang=js&"
import style0 from "./job.vue?vue&type=style&index=0&id=1d90d99e&prod&scoped=true&lang=less&"
import style1 from "./job.vue?vue&type=style&index=1&id=1d90d99e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d90d99e",
  null
  
)

export default component.exports